import React, { useState } from 'react';
import { AppLayout } from './components/layout/AppLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { TenantList } from './pages/admin/TenantList';
import { TenantDetail } from './pages/admin/TenantDetail';
import { ClubDashboard } from './pages/club/ClubDashboard';
import { CompanyDirectory } from './pages/network/CompanyDirectory';
import { CompanyProfile } from './pages/network/CompanyProfile';
import { PeopleDirectory } from './pages/network/PeopleDirectory';
import { PersonProfile } from './pages/network/PersonProfile';
import { EventList } from './pages/events/EventList';
import { EventDetail } from './pages/events/EventDetail';
import { FeedPage } from './pages/feed/FeedPage';
import { ChallengePage } from './pages/gamification/ChallengePage';
import { MessagesPage } from './pages/messages/MessagesPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { tenants } from './data/mockData';
import { LoginPage } from './pages/auth/LoginPage';
export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentView, setCurrentView] = useState<'admin' | 'club'>('admin');
  const [currentPage, setCurrentPage] = useState<string>('dashboard');
  // State for selected entities
  const [selectedTenantId, setSelectedTenantId] = useState<string | null>(null);
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState<string | null>(null);
  const [selectedPersonId, setSelectedPersonId] = useState<string | null>(null);
  // Default tenant for club view if none selected
  const activeTenantId = selectedTenantId || tenants[0].id;
  const activeTenant = tenants.find(t => t.id === activeTenantId);
  const handleNavigate = (page: string, id?: string) => {
    setCurrentPage(page);
    if (page === 'tenant-detail' && id) setSelectedTenantId(id);
    if (page === 'event-detail' && id) setSelectedEventId(id);
    if (page === 'company-profile' && id) setSelectedCompanyId(id);
    if (page === 'person-profile' && id) setSelectedPersonId(id);
  };
  const handleToggleView = () => {
    const newView = currentView === 'admin' ? 'club' : 'admin';
    setCurrentView(newView);
    setCurrentPage('dashboard');
  };
  const handleSwitchToClub = (tenantId: string) => {
    setSelectedTenantId(tenantId);
    setCurrentView('club');
    setCurrentPage('dashboard');
  };
  const renderPage = () => {
    if (currentView === 'admin') {
      switch (currentPage) {
        case 'dashboard':
          return <AdminDashboard onNavigate={handleNavigate} data-id="element-0" />;
        case 'tenants':
          return <TenantList onNavigate={handleNavigate} data-id="element-1" />;
        case 'tenant-detail':
          return <TenantDetail tenantId={selectedTenantId!} onNavigate={handleNavigate} onSwitchToClub={handleSwitchToClub} data-id="element-2" />;
        default:
          return <AdminDashboard onNavigate={handleNavigate} data-id="element-3" />;
      }
    } else {
      // Club View
      if (!activeTenant) return <div data-id="element-4">Tenant nicht gefunden</div>;
      switch (currentPage) {
        case 'dashboard':
          return <ClubDashboard tenant={activeTenant} onNavigate={handleNavigate} data-id="element-5" />;
        case 'network-companies':
          return <CompanyDirectory tenantId={activeTenant.id} onNavigate={handleNavigate} data-id="element-6" />;
        case 'company-profile':
          return <CompanyProfile companyId={selectedCompanyId!} onNavigate={handleNavigate} data-id="element-7" />;
        case 'network-people':
          return <PeopleDirectory tenantId={activeTenant.id} onNavigate={handleNavigate} data-id="element-8" />;
        case 'person-profile':
          return <PersonProfile personId={selectedPersonId!} onNavigate={handleNavigate} data-id="element-9" />;
        case 'events':
          return <EventList tenantId={activeTenant.id} onNavigate={handleNavigate} data-id="element-10" />;
        case 'event-detail':
          return <EventDetail eventId={selectedEventId!} onNavigate={handleNavigate} data-id="element-11" />;
        case 'feed':
          return <FeedPage tenantId={activeTenant.id} onNavigate={handleNavigate} data-id="element-12" />;
        case 'messages':
          return <MessagesPage tenantId={activeTenant.id} onNavigate={handleNavigate} data-id="element-13" />;
        case 'challenges':
          return <ChallengePage tenantId={activeTenant.id} data-id="element-14" />;
        case 'settings':
          return <SettingsPage tenant={activeTenant} data-id="element-15" />;
        default:
          return <ClubDashboard tenant={activeTenant} onNavigate={handleNavigate} data-id="element-16" />;
      }
    }
  };
  if (!isLoggedIn) {
    return <LoginPage onLogin={() => setIsLoggedIn(true)} data-id="element-17" />;
  }
  return <AppLayout currentView={currentView} currentPage={currentPage} onNavigate={handleNavigate} onToggleView={handleToggleView} tenant={currentView === 'club' ? activeTenant : undefined} data-id="element-18">
      {renderPage()}
    </AppLayout>;
}